import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

export const useDeleteConversation = () => {
    const chatService = new ChatService();
    return useMutation({
        mutationFn: ({ conversationId }: { conversationId: string }) => chatService.deleteConversation(conversationId),
    });
};
